module.exports = __webpack_public_path__ + "assets/images/mega.b725d4886901029e271aeff70cdd2d72.png";